import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Martín G.',
  location: 'Buenos Aires',
  text: 'Cerré mi primera propiedad en 9 días. El contrato y el one-pager me hicieron ver como un profesional desde el primer contacto.',
  color: 'bg-blue-100 text-blue-600'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Córdoba',
  text: 'Tengo 4 propiedades bajo gestión y nunca tuve una propia. El sistema de captación del Tomo 2 es oro puro.',
  color: 'bg-purple-100 text-purple-600'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Mendoza',
  text: 'Pasé de 0 a $1.800 USD de comisiones mensuales en 4 meses. El Tomo 6 de finanzas me salvó con el tipo de cambio.',
  color: 'bg-pink-100 text-pink-600'
}];
export function SocialProof() {
  return <section className="py-16 bg-surface" data-id="element-242">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-243">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-244">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-primary" data-id="element-245">
              <div className="flex gap-1 mb-4" data-id="element-246">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-247" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-248">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-249">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm ${t.color}`} data-id="element-250">
                  {t.initials}
                </div>
                <div data-id="element-251">
                  <div className="font-bold text-gray-900" data-id="element-252">{t.name}</div>
                  <div className="text-xs text-gray-500" data-id="element-253">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}